<template>
  <v-chip
    :class="classes"
    dark
  >
    <slot/>
  </v-chip>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      require: true
    }
  },

  computed: {
    classes() {
      return {
        'subject-chip' : true,
        [`${this.type}`] : true,
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.subject-chip
  min-width 64px
  height 18px !important
  font-size 11px !important
  font-weight bold
  display inline-block

types = {
  'ko': {
    'background-color': #c44c32 !important,
    'border-bottom': 1px solid #8a1c1c,
  },
  'su': {
    'background-color': #3E90C6 !important,
    'border-bottom': 1px solid #225f87,
  },
  'ei': {
    'background-color': #49A26E !important,
    'border-bottom': 1px solid #2c5e41,
  },
  'ri': {
    'background-color': #BE8540 !important,
    'border-bottom': 1px solid #875b26,
  },
  'sh': {
    'background-color': #7DA551 !important,
    'border-bottom': 1px solid #576e3d,
  },
  'gi': {
    'background-color': #3d84a8 !important,
    'border-bottom': 1px solid #184d68,
  },
  'ka': {
    'background-color': #d74443 !important,
    'border-bottom': 1px solid #a71211,
  },
  'ht': {
    'background-color': #e55f34 !important,
    'border-bottom': 1px solid #742a12,
  },
  'ch1': {
    'background-color': #7DA551 !important,
    'border-bottom': 1px solid #576e3d,
  },
  'ch2': {
    'background-color': #7DA551 !important,
    'border-bottom': 1px solid #576e3d,
  },
  're1': {
    'background-color': #7DA551 !important,
    'border-bottom': 1px solid #576e3d,
  },
  're23': {
    'background-color': #7DA551 !important,
    'border-bottom': 1px solid #576e3d,
  },
  'mi': {
    'background-color': #7DA551 !important,
    'border-bottom': 1px solid #576e3d,
  },
}

for type, values in types
  .{type}
    background-color values['background-color'];
    border-bottom values['border-bottom'];
</style>
